module.exports = __webpack_public_path__ + "img/POL.7ea212e8.svg";